import { useState } from 'react';

interface RefundItem {
  name: string;
  quantity: number;
  amount: number;
}

interface RefundRequest {
  reason: string;
  refund_items: RefundItem[];
  party_at_fault: 'UBER' | 'PARTNER';
}

interface UseRefundRequestProps {
  deliveryId: string;
}

export const useRefundRequest = ({ deliveryId }: UseRefundRequestProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const requestRefund = async (request: RefundRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`/api/uber/delivery/${deliveryId}/refund`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to request refund');
      }

      const data = await response.json();
      return data;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to request refund';
      setError(new Error(errorMessage));
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    requestRefund,
    isLoading,
    error,
  };
}; 